// 挂载到了全局 this.$XESLog
export const pageuid = {
  'course-center': '1.2.0',
  'course-detail': '1.3.0',
  'add-purchase': '1.5.0',
  search: '1.4.0'
}

export const logParamsDes = {
  key: '具体日志名称',
  eventid: '事件id',
  pageuid: 'pageuid',
  eventname: '上报类型: exposure(展现), click(点击)',
  action: '行为描述',
  clickid: 'clickid',
  content: '日志需要的数据',
  gradeid: '年级id，多个以逗号","链接',
  termid: '学期id',
  subjectid: '学科id',
  courseid: '课程id',
  rankid: '列表中位置（顺序第几个）',
  reccourseids: '推荐课程列表id，多个以逗号","链接',
  imageurl: '图片地址',
  imagetitle: '广告title',
  clickurl: '跳转地址',
  coursetype: '课程类别: 3:同步课，4:专题课'
}
const eventid = 'mallwww'
class XESLog {
  constructor(params = {}) {
    this.params = params
  }
  push({ eventname, target }, route) {
    try {
      if (!route) {
        throw new Error('no define route')
      }
      if (!eventname) {
        throw new Error('no define eventname')
      }
      const logParams = {
        eventid,
        ...this.params
      }
      logParams.pageuid = pageuid[route.name]
      logParams.eventname = eventname
      let paramsArr = []
      for (let key in logParams) {
        let value = logParams[key] === undefined ? '' : logParams[key]
        if (typeof value === 'object') {
          value = JSON.stringify(value).replace(/&/g, '')
        }
        const item = `${key}=${value}`
        paramsArr.push(item)
      }
      const paramsStr = paramsArr.join('&')
      switch (eventname) {
        case 'exposure': // 展现日志 --> a.gif
          window.__XES_LOG__.loadMsg(logParams)
          break
        case 'click': // 交互日志
          if (!target) {
            throw new Error('no define target')
          }
          const logData = {
            elem: target,
            params: paramsStr
          }
          window.__XES_LOG__.clickMsg(logData)
          break
        default:
          // 其他情况
          throw new Error(
            'For unregistered eventname, eventname only includes exposure(展现),click(交互).'
          )
      }
    } catch (error) {
      console.log(error)
    }
  }
}
export default XESLog



// WEBPACK FOOTER //
// ./src/defines/XESLog.js